import { FC, ReactNode, useState, useEffect } from "react";
import styles from "./modal.module.scss";
import { WithPortal } from "../withPortal/WithPortal";
import classNames from "classnames";
import { useEsc } from "../../hooks/useEsc";
import { IconButton } from "../iconButton/IconButton";
import { ReactComponent as CloseIcon } from "./assets/close.svg";

type Props = {
  children: ReactNode;
  close: () => void;
};
export const Modal: FC<Props> = ({ children, close }) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeHandler = () => {
    setIsOpen(false);
    setTimeout(() => {
      close();
    }, 100);
  };
  useEsc(closeHandler);
  useEffect(() => {
    setIsOpen(true);
  }, []);
  return (
    <WithPortal>
      <div className={styles.modal}>
        <div
          className={classNames(styles.underlay, { [styles.open]: isOpen })}
          onClick={closeHandler}
        />
        <div className={styles.content}>
          <div className={styles.close}>
            <IconButton onClick={close}>
              <CloseIcon />
            </IconButton>
          </div>
          {children}
        </div>
      </div>
    </WithPortal>
  );
};
